import { css } from '@linaria/core'
import { style } from '#styles/index'

export const inputCss = `
  display: flex;
  align-items: center;

  padding: 4px 8px;
  border: 1px solid ${style.themeColors.lineInput};
  min-height: 30px;

  color: ${style.themeColors.textDefault};
  background-color: ${style.themeColors.backgroundDefault};
  outline: 2px solid transparent;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  outline-offset: -2px;

  &::placeholder {
    color: ${style.themeColors.textDeselected};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    border-color: ${style.themeColors.lineInputHover}
  }

  &:focus {
    outline-color: ${style.themeColors.lineFocus};
    border-color: ${style.themeColors.lineFocus};
  }

  &:disabled {
    pointer-events: none;
    border-color: ${style.themeColors.textDeselected};
    color: ${style.themeColors.textDeselected};
    background: ${style.themeColors.backgroundBoxed};
  }

  &.without-label {
    margin-top: 20px;
  }
  
  &.without-error {
    margin-bottom: 20px;
  }
  
  &.slim, &.without-error.slim, &.without-label.slim, &.without-label.without-error.slim {
    margin-bottom: 0;
    margin-top: 0;
  }

  &.with-error {
    border-color: ${style.themeColors.textDanger};
    &:hover {
      border-color: ${style.themeColors.textImportant};
    }
    &:focus {
      outline-color: ${style.themeColors.textImportant};
    }
  }
`

export const inputCssClass = css`${inputCss}`
